"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORIGINAL = exports.STANDARD = exports.LEGACY = exports.HIDE_BUTTON = exports.SHOW_BUTTON = exports.PCW_MESSAGE_PASSWORD_NEEDS_LETTER_OR_NUMBER = exports.PCW_MESSAGE_PASSWORD_NEEDS_NUMBER = exports.PCW_MESSAGE_PASSWORD_NEEDS_LETTER = exports.PCW_MESSAGE_PASSWORD_TOO_LONG = exports.PCW_MESSAGE_PASSWORD_TOO_SHORT = exports.MESSAGE_DOES_NOT_MEET_REQUIREMENTS = exports.PCW_REQUIREMENT_PREVIOUS_PASSWORDS = exports.PCW_REQUIREMENT_COMMON_BAD_PASSWORDS = exports.PCW_REQUIREMENT_REPEATED_PATTERNS = exports.PCW_REQUIREMENT_PERSONAL_INFO = exports.PCW_REQUIREMENT_SINGULAR_COX_BRANDS = exports.PCW_REQUIREMENT_CONTAIN_LETTER_OR_NUMBER = exports.PCW_REQUIREMENT_CONTAIN_LETTER_AND_NUMBER = exports.PCW_REQUIREMENT_CHARACTER_COUNT = exports.PCW_REQUIREMENT_PASSWORD_MAY_NOT_CONTAIN = exports.PCW_REQUIREMENT_PASSWORD_MUST = exports.REQUIREMENT_LETTER_OR_NUMBER = exports.REQUIREMENT_NO_COMMON_PASSWORD = exports.REQUIREMENT_SPECIAL_CHARACTERS = exports.REQUIREMENT_CHARACTER_COUNT = exports.REQUIREMENT_LETTER_AND_NUMBER = exports.REQUIREMENT_CANNOT_REPEAT = exports.REQUIREMENT_NO_USERNAME = void 0; // REQUIREMENTS LIST

var REQUIREMENT_NO_USERNAME = "requirementBox.requirements.cannot_contain_username";
exports.REQUIREMENT_NO_USERNAME = REQUIREMENT_NO_USERNAME;
var REQUIREMENT_CANNOT_REPEAT = "requirementBox.requirements.cannot_repeat_previous";
exports.REQUIREMENT_CANNOT_REPEAT = REQUIREMENT_CANNOT_REPEAT;
var REQUIREMENT_LETTER_AND_NUMBER = "requirementBox.requirements.contain_letter_and_number";
exports.REQUIREMENT_LETTER_AND_NUMBER = REQUIREMENT_LETTER_AND_NUMBER;
var REQUIREMENT_CHARACTER_COUNT = "requirementBox.requirements.character_count";
exports.REQUIREMENT_CHARACTER_COUNT = REQUIREMENT_CHARACTER_COUNT;
var REQUIREMENT_SPECIAL_CHARACTERS = "requirementBox.requirements.special_characters";
exports.REQUIREMENT_SPECIAL_CHARACTERS = REQUIREMENT_SPECIAL_CHARACTERS;
var REQUIREMENT_NO_COMMON_PASSWORD = "requirementBox.requirements.cannot_be_common_password";
exports.REQUIREMENT_NO_COMMON_PASSWORD = REQUIREMENT_NO_COMMON_PASSWORD;
var REQUIREMENT_LETTER_OR_NUMBER = "requirementBox.requirements.contain_letter_or_number"; // NEW PCW REQUIREMENTS LIST

exports.REQUIREMENT_LETTER_OR_NUMBER = REQUIREMENT_LETTER_OR_NUMBER;
var PCW_REQUIREMENT_PASSWORD_MUST = "pcw.requirements.password_must";
exports.PCW_REQUIREMENT_PASSWORD_MUST = PCW_REQUIREMENT_PASSWORD_MUST;
var PCW_REQUIREMENT_PASSWORD_MAY_NOT_CONTAIN = "pcw.requirements.password_may_not_contain";
exports.PCW_REQUIREMENT_PASSWORD_MAY_NOT_CONTAIN = PCW_REQUIREMENT_PASSWORD_MAY_NOT_CONTAIN;
var PCW_REQUIREMENT_CHARACTER_COUNT = "pcw.requirements.character_count";
exports.PCW_REQUIREMENT_CHARACTER_COUNT = PCW_REQUIREMENT_CHARACTER_COUNT;
var PCW_REQUIREMENT_CONTAIN_LETTER_AND_NUMBER = "pcw.requirements.contain_letter_and_number";
exports.PCW_REQUIREMENT_CONTAIN_LETTER_AND_NUMBER = PCW_REQUIREMENT_CONTAIN_LETTER_AND_NUMBER;
var PCW_REQUIREMENT_CONTAIN_LETTER_OR_NUMBER = "pcw.requirements.contain_letter_or_number";
exports.PCW_REQUIREMENT_CONTAIN_LETTER_OR_NUMBER = PCW_REQUIREMENT_CONTAIN_LETTER_OR_NUMBER;
var PCW_REQUIREMENT_SINGULAR_COX_BRANDS = "pcw.requirements.singular_cox_brands";
exports.PCW_REQUIREMENT_SINGULAR_COX_BRANDS = PCW_REQUIREMENT_SINGULAR_COX_BRANDS;
var PCW_REQUIREMENT_PERSONAL_INFO = "pcw.requirements.personal_info";
exports.PCW_REQUIREMENT_PERSONAL_INFO = PCW_REQUIREMENT_PERSONAL_INFO;
var PCW_REQUIREMENT_REPEATED_PATTERNS = "pcw.requirements.repeated_patterns";
exports.PCW_REQUIREMENT_REPEATED_PATTERNS = PCW_REQUIREMENT_REPEATED_PATTERNS;
var PCW_REQUIREMENT_COMMON_BAD_PASSWORDS = "pcw.requirements.common_bad_passwords";
exports.PCW_REQUIREMENT_COMMON_BAD_PASSWORDS = PCW_REQUIREMENT_COMMON_BAD_PASSWORDS;
var PCW_REQUIREMENT_PREVIOUS_PASSWORDS = "pcw.requirements.previous_passwords"; // ERROR MESSAGES

exports.PCW_REQUIREMENT_PREVIOUS_PASSWORDS = PCW_REQUIREMENT_PREVIOUS_PASSWORDS;
var MESSAGE_DOES_NOT_MEET_REQUIREMENTS = "requirementBox.messages.does_not_meet_requirements"; // NEW PCW ERROR MESSAGES

exports.MESSAGE_DOES_NOT_MEET_REQUIREMENTS = MESSAGE_DOES_NOT_MEET_REQUIREMENTS;
var PCW_MESSAGE_PASSWORD_TOO_SHORT = "pcw.messages.password_too_short";
exports.PCW_MESSAGE_PASSWORD_TOO_SHORT = PCW_MESSAGE_PASSWORD_TOO_SHORT;
var PCW_MESSAGE_PASSWORD_TOO_LONG = "pcw.messages.password_too_long";
exports.PCW_MESSAGE_PASSWORD_TOO_LONG = PCW_MESSAGE_PASSWORD_TOO_LONG;
var PCW_MESSAGE_PASSWORD_NEEDS_LETTER = "pcw.messages.password_needs_letter";
exports.PCW_MESSAGE_PASSWORD_NEEDS_LETTER = PCW_MESSAGE_PASSWORD_NEEDS_LETTER;
var PCW_MESSAGE_PASSWORD_NEEDS_NUMBER = "pcw.messages.password_needs_number";
exports.PCW_MESSAGE_PASSWORD_NEEDS_NUMBER = PCW_MESSAGE_PASSWORD_NEEDS_NUMBER;
var PCW_MESSAGE_PASSWORD_NEEDS_LETTER_OR_NUMBER = "pcw.messages.password_needs_letter_or_number"; // PASSWORD INPUT BOX

exports.PCW_MESSAGE_PASSWORD_NEEDS_LETTER_OR_NUMBER = PCW_MESSAGE_PASSWORD_NEEDS_LETTER_OR_NUMBER;
var SHOW_BUTTON = "passwordInputBox.show_button";
exports.SHOW_BUTTON = SHOW_BUTTON;
var HIDE_BUTTON = "passwordInputBox.hide_button"; // PASSWORD POLICY

exports.HIDE_BUTTON = HIDE_BUTTON;
var LEGACY = "legacy";
exports.LEGACY = LEGACY;
var STANDARD = "standard";
exports.STANDARD = STANDARD;
var ORIGINAL = "original";
exports.ORIGINAL = ORIGINAL;